/** 国家/区域名称 */
export type CountryCode = 'SG' | 'MY' | 'TH' | 'VN' | 'US' | 'ID' | 'CN' | 'TW' | 'AU' | 'JP'

/** 需要拆分姓名的国家 */
export const NEED_SPLIT_NAME_COUNTRY = ['JP']

/**
 * 拆分的字段
 * tips: 顺序不能换，有要求的
 */
export const SPLIT_NAMES = ['firstName', 'lastName']

export const JOIN_NAME = 'name'
